/**
 * Admin Simulations page component.
 *
 * Route: `/admin/simulations`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminSimulationsPage
 */

import SimulationManager from '@/components/admin/SimulationManager';

export default function AdminSimulationsPage() {
  return <SimulationManager />;
}
